import React from 'react';
import {
  FormDataConsumer,
  ReferenceArrayInput,
  SelectArrayInput,
  SelectInput,
  TextInput,
  required,
} from 'react-admin';
import { Alert } from '@mui/material';
import {
  WhatsappScope,
  WhatsappActorType,
  SummaryFrequency,
} from '../../models/whatsappNumber';

/**
 * Campos compartilhados entre cadastrar e editar.
 *
 * O escopo é escolha explícita: "rede inteira" ou "postos específicos". Não
 * existe estado intermediário em que a lista vazia signifique tudo.
 */
const WhatsappNumberForm = () => (
  <>
    <Alert severity="warning" sx={{ mb: 2 }}>
      Este número vai receber dados da sua rede sem precisar de senha.
      Cadastre apenas números de pessoas que você conhece, e confira os dígitos
      antes de salvar.
    </Alert>

    <TextInput
      source="phone"
      label="Número do WhatsApp"
      validate={[required()]}
      helperText="Com DDD. Ex.: (11) 98765-4321"
      sx={{ minWidth: 300 }}
    />

    <TextInput
      source="displayName"
      label="Quem é"
      validate={[required()]}
      helperText='Só para você se achar na lista. Ex.: "João — dono".'
      sx={{ minWidth: 300 }}
    />

    <SelectInput
      source="actorType"
      label="Papel"
      choices={WhatsappActorType.actorChoices}
      defaultValue={WhatsappActorType.owner}
      validate={[required()]}
      sx={{ minWidth: 300 }}
    />

    <SelectInput
      source="scope"
      label="O que este número enxerga"
      choices={WhatsappScope.scopeChoices}
      defaultValue={WhatsappScope.chain}
      validate={[required()]}
      helperText="Escolha postos específicos quando a pessoa não puder ver a rede toda."
      sx={{ minWidth: 300 }}
    />

    <FormDataConsumer>
      {({ formData }) =>
        formData?.scope === WhatsappScope.places ? (
          <ReferenceArrayInput
            source="placeIds"
            reference="stations"
            perPage={200}
            sort={{ field: 'name', order: 'ASC' }}
          >
            <SelectArrayInput
              label="Postos"
              optionText="name"
              validate={[required()]}
              helperText="Perguntas que só existem para a rede inteira serão recusadas."
              sx={{ minWidth: 300 }}
            />
          </ReferenceArrayInput>
        ) : null
      }
    </FormDataConsumer>

    <SelectInput
      source="summaryFrequency"
      label="Resumo automático"
      choices={SummaryFrequency.frequencyChoices}
      defaultValue={SummaryFrequency.none}
      helperText="Com que frequência este número recebe o resumo, sem pedir."
      sx={{ minWidth: 300 }}
    />
  </>
);

export default WhatsappNumberForm;
